import React, { useCallback } from "react";
import moment from "moment";

import { FileDownloadOutlined as DownloadTasks } from "@mui/icons-material";
import { useStatusMissing } from "../../../../../utils/reactQuery/statusMissing";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import { generateCSV } from "../../../../../utils";
import { CustomButton } from "../../../../../components/Button/Button";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { useSelector } from "react-redux";

export const DownloadMissingStatus = React.memo(() => {
  const [filterBoard] = useCustomSearchParams("missingStatus");
  const filterBoardObj = JSON.parse(filterBoard);
  const isMobile = useResponsive("down", "md");
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );

  const start_date = filterBoardObj
    ? moment(filterBoardObj.startDate).format("YYYY-MM-DD")
    : "";
  const end_date = filterBoardObj
    ? moment(filterBoardObj.endDate).format("YYYY-MM-DD")
    : "";

  const { isLoading, error, statusMissing, isError, refetch, isRefetching } =
    useStatusMissing({ start_date, end_date });

  const generateCSVFile = useCallback(() => {
    const data = statusMissing?.data?.data?.responseData || [];
    
    const formattedData =
      groupingUser.length > 0
        ? data
            ?.filter((item) =>
              groupingUser?.[0]?.users?.some(
                (user) => user.user_id === item.user_id
              )
            )
            .map((item) => ({
              "User name": item.username,
              Date: moment(item.date).format("DD/MM/YYYY"),
              Delay: item.delay || "-",
              "Hour spent": `${item.total_hours_spent}/8`,
              Notes: `${item.leave_type ? item.leave_type : "none"} ${
                item.reason ? `: ${item.reason}` : ""
              }`,
            }))
        : data.map((item) => ({
            "User name": item.username,
            Date: moment(item.date).format("DD/MM/YYYY"),
            Delay: item.delay || "-",
            "Hour spent": `${item.total_hours_spent}/8`,
            Notes: `${item.leave_type ? item.leave_type : "none"} ${
              item.reason ? `: ${item.reason}` : ""
            }`,
          }));

    generateCSV(formattedData, "missing-status");
  }, [statusMissing, groupingUser]);

  return (
    <>
      <CustomButton
        onClick={generateCSVFile}
        className="theme-bg-color capitalize ml-3 download-missing-status"
        variant="contained"
        color={"warning"}
        startIcon={<DownloadTasks />}
      >
        {!isMobile ? "Download CSV" : ""}
      </CustomButton>
    </>
  );
});
